import { FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material"

const RadioButtons = (props) => {
  const { setPageSize, pageSize } = props
  return (
    <Grid item>
      <RadioGroup
        row
        aria-label="pageSize"
        name="pageSize"
        value={pageSize}
        onChange={(e) => {
          setPageSize(Number(e.target.value))
        }}>
        {[25, 50, 75].map((pageSize, index, array) => (
          <FormControlLabel
            key={pageSize}
            value={pageSize}
            control={<Radio />}
            label={pageSize}
            sx={{ marginRight: index === array.length - 1 ? "0px" : "16px" }}
          />
        ))}
      </RadioGroup>
    </Grid>
  )
}

export default RadioButtons
